// extracted by mini-css-extract-plugin
export default {"tab":"Profile_tab__GTosW"};